// Chuẩn hoá ngày các mốc lộ trình (#x5-frame3).
//
// Vì sao phải có JS thay vì chèn thẳng dấu chấm bằng CSS:
// text ngày là nội dung CMS nhập tay, mỗi mốc một kiểu — có mốc "12.2025",
// có mốc ".05.2026" (người nhập tự thêm chấm cho đủ), mốc cuối là "COMING SOON"
// không có ngày. Nếu để CSS chèn chấm vô điều kiện thì mốc đã có chấm sẽ ra
// hai chấm và mốc "COMING SOON" mọc chấm thừa.
// Ở đây JS bóc chấm/khoảng trắng dư rồi chỉ gắn cờ .has-date-sep cho mốc thật sự
// có dạng NGÀY + THÁNG.NĂM; CSS lo phần vẽ chấm (và chỉ vẽ ở PC — bản mobile xếp
// ngày trên, tháng.năm dưới nên không cần chấm ngăn).
(function () {
	'use strict';

	var DAY_RE = /^\d{1,2}$/; // "15", "8"
	var MONTH_YEAR_RE = /^\d{1,2}\.\d{4}$/; // "12.2025"
	var TRIM_RE = /^[\s.]+|[\s.]+$/g; // chấm / khoảng trắng dư ở hai đầu

	function normalizeDates() {
		var dates = document.querySelectorAll('#x5-frame3 .frame3__card-date');

		for (var i = 0; i < dates.length; i++) {
			var el = dates[i];
			var dayEl = el.querySelector('b');
			var monthEl = el.querySelector('i');

			// gỡ cờ trước để hàm chạy lại nhiều lần vẫn ra đúng một kết quả
			el.classList.remove('has-date-sep');

			if (!dayEl || !monthEl) continue;

			var day = dayEl.textContent.replace(TRIM_RE, '');
			var monthYear = monthEl.textContent.replace(TRIM_RE, '');

			// không đúng dạng ngày (vd "COMING SOON", ô trống, chữ) → để nguyên, không chấm
			if (!DAY_RE.test(day) || !MONTH_YEAR_RE.test(monthYear)) continue;

			if (dayEl.textContent !== day) dayEl.textContent = day;
			if (monthEl.textContent !== monthYear) monthEl.textContent = monthYear;

			el.classList.add('has-date-sep');
		}
	}

	// Khung mốc cuộn native (touch/trackpad); chuột PC cần thêm kéo tay.
	// Kéo thì tắt snap để không giật, thả ra bật lại cho browser tự hít vào thẻ gần nhất.
	function enableMouseDrag(track) {
		var startX = 0;
		var startScroll = 0;

		track.addEventListener('pointerdown', function (e) {
			if (e.pointerType !== 'mouse' || e.button !== 0) return;
			startX = e.clientX;
			startScroll = track.scrollLeft;
			track.classList.add('is-dragging');
			track.setPointerCapture(e.pointerId);
		});

		track.addEventListener('pointermove', function (e) {
			if (!track.classList.contains('is-dragging')) return;
			track.scrollLeft = startScroll - (e.clientX - startX);
		});

		function stopDrag() {
			track.classList.remove('is-dragging');
		}
		track.addEventListener('pointerup', stopDrag);
		track.addEventListener('pointercancel', stopDrag);
	}

	// Mốc đang diễn ra có thể nằm ngoài 4 thẻ đầu → cuộn vừa đủ cho nó lộ trọn
	function revealActiveCard(track) {
		var card = track.querySelector('.frame3__card.active');
		if (!card) return;

		var isRow = track.scrollWidth > track.clientWidth;
		var start = isRow ? card.offsetLeft : card.offsetTop;
		var size = isRow ? card.offsetWidth : card.offsetHeight;
		var view = isRow ? track.clientWidth : track.clientHeight;
		var overflowEnd = start + size - view;

		if (overflowEnd > 0) {
			if (isRow) track.scrollLeft = overflowEnd;
			else track.scrollTop = overflowEnd;
		}
	}

	function initTrack() {
		var section = document.querySelector('#x5-frame3');
		var track = section && section.querySelector('.frame3__cards');
		if (!track) return;

		var isScrollable = track.scrollWidth > track.clientWidth || track.scrollHeight > track.clientHeight;
		section.classList.toggle('is-scrollable', isScrollable);

		enableMouseDrag(track);
		revealActiveCard(track);
	}

	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', normalizeDates);
	} else {
		normalizeDates();
	}
	// đo kích thước khung cần layout xong (lib scale + ẩn màn loading tới load)
	window.addEventListener('load', initTrack);
})();
